/* eslint-disable */
export default {
  Title: 'Title',
  TitlePart1: 'TitlePart1',
  TitlePart2: 'TitlePart2',
  TitlePart3: 'TitlePart3',
  Text: 'Text',
  TextPart2: 'TextPart2',
  Headline: 'Headline',
  LongHeadline: 'LongHeadline',
  LongHeadlines: 'LongHeadlines',
  BusinessName: 'BusinessName',
  DisplayUrl: 'DisplayUrl',
  FinalUrl: 'FinalUrls',
  Path1: 'Path1',
  Path2: 'Path2',
  MobileFinalUrl: 'MobileFinalUrls',
  DestinationUrl: 'DestinationUrl',
  DevicePreference: 'DevicePreference',
  Headlines: 'Headlines',
  Descriptions: 'Descriptions'
};

